import { motion } from "motion/react";

import { useTheme } from "@up/data";
import { Toast } from "@up/ui";

const MOTION = {
  props: {
    animate: {
      opacity: 1,
      rotate: 0,
      y: 0,
    },
    initial: {
      opacity: 0,
      rotate: -9,
      y: 100,
    },
    transition: {
      type: "spring",
      mass: 1,
      stiffness: 150,
    },
  },
} as const;

export function ScholarshipSaveError() {
  const theme = useTheme();

  return (
    <motion.div {...MOTION.props}>
      <Toast variant="error">
        We could not save your progress. Please try again in a few moments or{" "}
        <a className="underline" href={`mailto:${theme.supportEmail}`}>
          email support
        </a>
        .
      </Toast>
    </motion.div>
  );
}
